import React from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form';

import { TextField } from 'redux-form-material-ui';
import FlatButton from 'material-ui/FlatButton';

import { CSSTransitionGroup } from 'react-transition-group';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import * as validator from 'helpers/Validator';

import RemoveIcon from 'components/shared/form-components/RemoveIcon';
import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';

class FloorPlan extends React.Component {
  UNSAFE_componentWillMount() {
    this.nameUnique = (value, allValues) =>
      validator.unique(value, allValues, this.props.fields.name, 'name');
  }

  render() {
    const { name, fields, index } = this.props;
    const title = (fields.get(index) || {}).name || `Floor Plan ${index + 1}`;

    return (
      <div key={name}>
        <h4 style={{ lineHeight: '26px' }}>
          {title}
          <RemoveIcon onClick={() => fields.remove(index)} />
        </h4>

        <div className="row">
          <div className="col-xs-8 col-xs-offset-2" style={{ marginTop: '10px' }}>
            <Field
              name={`${name}.photo`}
              style={{ border: `1px dashed ${colors.LIGHT_GRAY}` }}
              labelText="Click to add photo"
              multiple={false}
              validate={validator.required}
              component={ReduxDropzone}
              fileValidation="image/*"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: 'center' }}>
            <Field
              name={`${name}.name`}
              type="text"
              component={TextField}
              validate={[this.nameUnique, validator.required]}
              floatingLabelText="Floor Plan Name"
              style={{
                marginTop: '-15px',
                fontSize: '14px',
                width: '100%',
              }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ marginTop: '10px' }}>
            <Field
              name={`${name}.description`}
              fullWidth
              component={TextField}
              label="Details"
              validate={[validator.required]}
              floatingLabelText="Floor Plan Description"
              style={{
                marginTop: '-15px',
                fontSize: '14px',
                width: '100%',
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

class FloorPlans extends React.Component {
  render() {
    const { fields } = this.props;

    return (
      <div>
        <CSSTransitionGroup
          transitionName="add_unit"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {fields.map((floorPlan, index) => (
            <FloorPlan name={floorPlan} fields={fields} index={index} />
          ))}

          <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
            <FlatButton
              label="Add Additional Floor Plan"
              type="button"
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={{ color: 'white' }}
              onClick={() => fields.push({})}
            />
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

class FloorPlansPage extends React.Component {
  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="row" style={{ marginBottom: '25px' }}>
        <div>
          <h3 style={{ textAlign: 'center', margin: '25px 0px 5px 0px' }}>Floor Plan(s)</h3>
          <p style={{ textAlign: 'center', marginBottom: '15px' }}>
            Create floor plans by giving them a name and a description.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <FieldArray name="floor_plans" component={FloorPlans} />
        </form>

        <div id="button" style={{ marginBottom: '75px' }} />
      </div>
    );
  }
}

FloorPlansPage = reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(FloorPlansPage);

export default FloorPlansPage;
